/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This service delivers the **timetable-based public transportation routing** used across SBB’s journey-planning channels, including [sbb.ch](https://www.sbb.ch/) and the [SBB Mobile](https://apps.apple.com/ch/app/sbb-mobile/id294855237) app.   This API is provided **exclusively to SBB internal stakeholders and accredited partners**. Organizations without SBB affiliation are encouraged to use the [Open Journey Planner (OJP)](https://opentransportdata.swiss/en/cookbook/open-journey-planner-ojp/), accessible through the [Open Transport Data](https://opentransportdata.swiss/en/) portal.  ### Approval Process   #### Step 1 Sign up below, complete the required account fields and confirm your registration.  #### Step 2 * **Internal** (SBB employees): Open and complete the [questionnaire](https://sbb.sharepoint.com/:b:/s/journey/IQAz0q3KNhLsRoMwqBu58p6RAawc_K4SUFJGp6xEgVTHsOw?e=RkWuxv), then email it to us (see \'Contact -> E-Mail\') with the exact subject line **Request: Sign Up Journey-Service**.  * **External** (third-party companies): Request the questionnaire by sending us an e-mail (see \'Contact -> E-Mail\').  With all the information in hand, a decision to approve/reject the request will be made and you will be notified accordingly.   ### Approved consumers * Please consult the [**Developer resources**](https://github.com/SchweizerischeBundesbahnen/journey-service/tree/master) for detailed information on Journey-Service concepts, usage, and debugging. * Further details about each endpoint are available in the **Documentation** section of this website. * For release notes, please refer to the **Blog** section on this website.  For further questions, contact us via e-mail (see \'Contact -> E-Mail\').  
 *
 * The version of the OpenAPI document: 3.37.1
 * Contact: journey@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { AlternateMatchEnum } from '../model/models';
import { Problem } from '../model/models';
import { RealtimeModeEnum } from '../model/models';
import { StrictnessForTripIdEnum } from '../model/models';
import { TrainStopAssignmentsEnum } from '../model/models';
import { TripAlternativesRequestBody } from '../model/models';
import { TripResponse } from '../model/models';
import { TripsByLegRequestBody } from '../model/models';
import { TripsByOriginAndDestinationRequestBody } from '../model/models';
import { TripsIntervalByOriginAndDestinationRequestBody } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class TripsV3Service {

    protected basePath = 'https://journey-service.api.sbb.ch';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get a List of &#x60;Trip&#x60; [0..maxAlternatives] with changed arrival/departure times at a concrete via/transfer point on a given &#x60;Trip::id&#x60; (aka trip.alternatives).
     * @param tripAlternativesRequestBody 
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAlternativeTripsById(tripAlternativesRequestBody: TripAlternativesRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<TripResponse>;
    public getAlternativeTripsById(tripAlternativesRequestBody: TripAlternativesRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<TripResponse>>;
    public getAlternativeTripsById(tripAlternativesRequestBody: TripAlternativesRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<TripResponse>>;
    public getAlternativeTripsById(tripAlternativesRequestBody: TripAlternativesRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (tripAlternativesRequestBody === null || tripAlternativesRequestBody === undefined) {
            throw new Error('Required parameter tripAlternativesRequestBody was null or undefined when calling getAlternativeTripsById.');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<TripResponse>(`${this.configuration.basePath}/v3/trips/alternatives`,
            tripAlternativesRequestBody,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get corresponding trip for a specific &#x60;Trip::id&#x60;.
     * Typically there is [1] hit but failing &#x60;Problem&#x60; must be expected in realtime scenarios or older &#x60;Trip::id\&#39;s&#x60;. Rare [2] hit cases might resolve from includeAlternateMatch&#x3D;BOTH. &lt;br/&gt;The response can be cached during 15 seconds.
     * @param id &#x60;Trip::id&#x60; to be refreshed.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param ifNoneMatch An optional ETag given in a previous response header _ETag_ and which can save traffic network. See [J-S caching](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/technical/TechnicalAspects.md#caching)
     * @param date Alternate (local) date if reconstruction is desired for a specific date other than given by &#x60;Trip::id&#x60;. Successful resolution depends on operating-days of the Line and other aspects (such as period, realtime, ...).
     * @param realtimeMode The real-time information is available **only until the train arrival**, except for &#x60;/archive&#x60; which keep it.   x-extensible-enum:  - &#x60;REALTIME&#x60; potentially planned and RT **including non-rideable** (like cancelled) - &#x60;REALTIME_RIDEABLE&#x60; as REALTIME but **excluding non-rideable** - &#x60;OFF&#x60; **planned only**
     * @param retryFuzzy @Deprecated **Please switch to &#x60;strictness&#x3D;FUZZY&#x60;**.Due to changing &#x60;ServiceProduct::number&#x60; updates by Public Transport-Operators, the temporary &#x60;Trip::id&#x60; might not resolve any more after a while. Therefore true (not necessary for fresh Trips) will automatically retry to find the &#x60;Trip&#x60; assuming such a &#x60;ServiceProduct::number&#x60; adaption. **100% correctness cannot be guaranteed if &#x60;TripResponse::serviceProductAdapted&#x60; is true, do validate found &#x60;Trip&#x60; whether it might be what you are looking for!**
     * @param strictness Due to changing &#x60;ServiceProduct::number&#x60; or DepartureTime updates by Public Transport-Operators, the temporary &#x60;Trip::id&#x60; might not resolve any more after a while. Therefore it is possible to influence the Trip refresh (not necessary for fresh Trips).   x-extensible-enum:  - &#x60;SIMILAR_TIME&#x60;: On resolving the TripId, the newly found departure time may differ slightly from the departure time of the TripId - &#x60;EXACT_TIME&#x60;: On resolving the TripId, the newly found departure time must exactly match the departure time of the TripId - &#x60;FUZZY&#x60;: Ingore the given &#x60;ServiceProduct::number&#x60; and try to resolve the TripId with a larger timerange**100% correctness cannot be guaranteed if &#x60;TripResponse::serviceProductAdapted&#x60; is true, do validate found &#x60;Trip&#x60; whether it might be what you are looking for!**
     * @param includeAlternateMatch Post-filter to adjust cancelled/alternate 1:1 Trip cases per response (de:Ausfall/Ersatz) according to SBB BR, where other Trip\&#39;s remain as is.  x-extensible-enum:  - IRRELEVANT: no adaption - BOTH: as IRRELEVANT but some Note\&#39;s will be cloned from cancelled to 1:1 alternate Trip - ALTERNATE_ONLY: suppresses cancelled 1:1 Trip\&#39;s if matched with alternates - CANCELLED_ONLY: suppress exactly matching 1:1 alternates
     * @param includeRouteProjection With or without a plottable polyline for each &#x60;ServiceJourney::spatialProjection&#x60; (if available).  This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeOperatingDays &#x60;Trip::operatingPeriods&#x60; will always be returned if it is a **repeatable planned Trip over the period**. To enforce concrete planned dates in &#x60;OperatingPeriod::operatingDays&#x60;set &#x60;includeOperatingDays&#x3D;true&#x60; (PTRideLeg::serviceJourney::operationPeriods will remain empty, because whole Trip is of interest).  This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeSummary Create some summary facts about each Trip (useful for UI overviews).  This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeIntermediateStops Whether the &#x60;PTRideLeg\&#39;s&#x60; should include intermediate stops (between the passenger\&#39;s board and alight in &#x60;ServiceJourney::stopPoints&#x60;).  x-extensible-enum:  [ALL,NONE,BOARDING_ALIGHTING] where ALL is BOARDING_ALIGHTING plus virtual stops.
     * @param includeTrainStopAssignments Whether &#x60;PTRideLeg\&#39;s&#x60; should include &#x60;CompoundTrain\&#39;s&#x60;(aka formation, composition). However, &#x60;CompoundTrain\&#39;s&#x60; at any &#x60;ScheduledStopPoint&#x60; on the &#x60;ServiceJourney&#x60; may be loaded separately by &#x60;/v3/vehicle-journeys/by-stoppoints&#x60;. Possible values: - NONE none at all, though a &#x60;PTRideLeg::trainStopAssignmentHint&#x60; is always given. - ORIGIN  &#x60;TrainStopAssignment\&#39;s&#x60; are added to first (departure) &#x60;ScheduledStopPoint&#x60; of each &#x60;PTRideLeg&#x60;  - ORIGIN_DESTINATION &#x60;TrainStopAssignment\&#39;s&#x60; are added to first (departure) and last (arrival) &#x60;ScheduledStopPoint&#x60; of each &#x60;PTRideLeg&#x60; having a &#x60;TrainStopAssignment&#x60; resp. a &#x60;CompoundTrain&#x60;.   This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeExitSide Add exit-side at last leg\&#39;s stop, if available.  This parameter has an impact on performance and/or response volume, set wisely!
     * @param excludeUnnecessaryTransfers Due to rare national/international routing implications in rare cases lead to non-necessary transfer\&#39;s between 2 &#x60;PTRideLeg\&#39;s&#x60; (if set false marked with a &#x60;Notice::name&#x60;&#x3D;\&quot;hi\&quot; \&#39;remain seated\&#39;). Setting this filter to true, merges these 2 &#x60;PTRideLeg\&#39;s&#x60; into one (only recommended for enduser channels like sbb.ch to simplify &#x60;Trip::legs&#x60;representation.)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTripsById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, date?: string, realtimeMode?: RealtimeModeEnum, retryFuzzy?: boolean, strictness?: StrictnessForTripIdEnum, includeAlternateMatch?: AlternateMatchEnum, includeRouteProjection?: boolean, includeOperatingDays?: boolean, includeSummary?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeTrainStopAssignments?: TrainStopAssignmentsEnum, includeExitSide?: boolean, excludeUnnecessaryTransfers?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<TripResponse>;
    public getTripsById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, date?: string, realtimeMode?: RealtimeModeEnum, retryFuzzy?: boolean, strictness?: StrictnessForTripIdEnum, includeAlternateMatch?: AlternateMatchEnum, includeRouteProjection?: boolean, includeOperatingDays?: boolean, includeSummary?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeTrainStopAssignments?: TrainStopAssignmentsEnum, includeExitSide?: boolean, excludeUnnecessaryTransfers?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<TripResponse>>;
    public getTripsById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, date?: string, realtimeMode?: RealtimeModeEnum, retryFuzzy?: boolean, strictness?: StrictnessForTripIdEnum, includeAlternateMatch?: AlternateMatchEnum, includeRouteProjection?: boolean, includeOperatingDays?: boolean, includeSummary?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeTrainStopAssignments?: TrainStopAssignmentsEnum, includeExitSide?: boolean, excludeUnnecessaryTransfers?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<TripResponse>>;
    public getTripsById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', ifNoneMatch?: string, date?: string, realtimeMode?: RealtimeModeEnum, retryFuzzy?: boolean, strictness?: StrictnessForTripIdEnum, includeAlternateMatch?: AlternateMatchEnum, includeRouteProjection?: boolean, includeOperatingDays?: boolean, includeSummary?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeTrainStopAssignments?: TrainStopAssignmentsEnum, includeExitSide?: boolean, excludeUnnecessaryTransfers?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTripsById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (date !== undefined && date !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>date, 'date');
        }
        if (realtimeMode !== undefined && realtimeMode !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>realtimeMode, 'realtimeMode');
        }
        if (retryFuzzy !== undefined && retryFuzzy !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>retryFuzzy, 'retryFuzzy');
        }
        if (strictness !== undefined && strictness !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>strictness, 'strictness');
        }
        if (includeAlternateMatch !== undefined && includeAlternateMatch !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeAlternateMatch, 'includeAlternateMatch');
        }
        if (includeRouteProjection !== undefined && includeRouteProjection !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeRouteProjection, 'includeRouteProjection');
        }
        if (includeOperatingDays !== undefined && includeOperatingDays !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeOperatingDays, 'includeOperatingDays');
        }
        if (includeSummary !== undefined && includeSummary !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeSummary, 'includeSummary');
        }
        if (includeIntermediateStops !== undefined && includeIntermediateStops !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeIntermediateStops, 'includeIntermediateStops');
        }
        if (includeTrainStopAssignments !== undefined && includeTrainStopAssignments !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeTrainStopAssignments, 'includeTrainStopAssignments');
        }
        if (includeExitSide !== undefined && includeExitSide !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeExitSide, 'includeExitSide');
        }
        if (excludeUnnecessaryTransfers !== undefined && excludeUnnecessaryTransfers !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>excludeUnnecessaryTransfers, 'excludeUnnecessaryTransfers');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }
        if (ifNoneMatch !== undefined && ifNoneMatch !== null) {
            headers = headers.set('If-None-Match', String(ifNoneMatch));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<TripResponse>(`${this.configuration.basePath}/v3/trips/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a &#x60;Trip&#x60; [0..1] with changed arrival/departure times at a concrete via/transfer point on a given &#x60;Trip::id&#x60; (aka partialTripSearch).
     * Useful to adapt a given &#x60;Trip&#x60; slightly with same origin/destination but _earlier arrival_ or _later departure_ at a desired via/transfer &#x60;ScheduledStopPoint&#x60; (similar effect could be gained by v3/trips/by-origin-destination &#x60;PTViaReference::waittime&#x60;). &#x60;TripResponse::paginationCursor&#x60; cannot be provided in this case.
     * @param id &#x60;v3.Trip::id&#x60; is a temporary TripContext describing a concrete rideable and priceable journey (and not to be understood as a guaranteed ID which might be cached forever)! Therefore proper reconstruction is not guaranteed (realtime aspects, lacking service-days in the future, ..)!
     * @param viaEarlierLaterContext &#x60;PTRideLeg::paginationCursor&#x60; previous- or next-value of a specific PTRideLeg within a Trip (given by its &#x60;id&#x60;). Use **previous** to arrive earlier at last stop (via), or **next** to depart later at first stop.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param additionalTransferTime Additional change time at Via to be changed expressed by related &#x60;viaEarlierLaterContext&#x60;.
     * @param includeAlternateMatch Post-filter to adjust cancelled/alternate 1:1 Trip cases per response (de:Ausfall/Ersatz) according to SBB BR, where other Trip\&#39;s remain as is.  x-extensible-enum:  - IRRELEVANT: no adaption - BOTH: as IRRELEVANT but some Note\&#39;s will be cloned from cancelled to 1:1 alternate Trip - ALTERNATE_ONLY: suppresses cancelled 1:1 Trip\&#39;s if matched with alternates - CANCELLED_ONLY: suppress exactly matching 1:1 alternates
     * @param includeRouteProjection With or without a plottable polyline for each &#x60;ServiceJourney::spatialProjection&#x60; (if available).  This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeSummary Create some summary facts about each Trip (useful for UI overviews).  This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeIntermediateStops Whether the &#x60;PTRideLeg\&#39;s&#x60; should include intermediate stops (between the passenger\&#39;s board and alight in &#x60;ServiceJourney::stopPoints&#x60;).  x-extensible-enum:  [ALL,NONE,BOARDING_ALIGHTING] where ALL is BOARDING_ALIGHTING plus virtual stops.
     * @param excludeUnnecessaryTransfers Due to rare national/international routing implications in rare cases lead to non-necessary transfer\&#39;s between 2 &#x60;PTRideLeg\&#39;s&#x60; (if set false marked with a &#x60;Notice::name&#x60;&#x3D;\&quot;hi\&quot; \&#39;remain seated\&#39;). Setting this filter to true, merges these 2 &#x60;PTRideLeg\&#39;s&#x60; into one (only recommended for enduser channels like sbb.ch to simplify &#x60;Trip::legs&#x60;representation.)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTripsByIdAndPartialSearchContext(id: string, viaEarlierLaterContext: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', additionalTransferTime?: number, includeAlternateMatch?: AlternateMatchEnum, includeRouteProjection?: boolean, includeSummary?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', excludeUnnecessaryTransfers?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<TripResponse>;
    public getTripsByIdAndPartialSearchContext(id: string, viaEarlierLaterContext: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', additionalTransferTime?: number, includeAlternateMatch?: AlternateMatchEnum, includeRouteProjection?: boolean, includeSummary?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', excludeUnnecessaryTransfers?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<TripResponse>>;
    public getTripsByIdAndPartialSearchContext(id: string, viaEarlierLaterContext: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', additionalTransferTime?: number, includeAlternateMatch?: AlternateMatchEnum, includeRouteProjection?: boolean, includeSummary?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', excludeUnnecessaryTransfers?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<TripResponse>>;
    public getTripsByIdAndPartialSearchContext(id: string, viaEarlierLaterContext: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', additionalTransferTime?: number, includeAlternateMatch?: AlternateMatchEnum, includeRouteProjection?: boolean, includeSummary?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', excludeUnnecessaryTransfers?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTripsByIdAndPartialSearchContext.');
        }
        if (viaEarlierLaterContext === null || viaEarlierLaterContext === undefined) {
            throw new Error('Required parameter viaEarlierLaterContext was null or undefined when calling getTripsByIdAndPartialSearchContext.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (additionalTransferTime !== undefined && additionalTransferTime !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>additionalTransferTime, 'additionalTransferTime');
        }
        if (includeAlternateMatch !== undefined && includeAlternateMatch !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeAlternateMatch, 'includeAlternateMatch');
        }
        if (includeRouteProjection !== undefined && includeRouteProjection !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeRouteProjection, 'includeRouteProjection');
        }
        if (includeSummary !== undefined && includeSummary !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeSummary, 'includeSummary');
        }
        if (includeIntermediateStops !== undefined && includeIntermediateStops !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeIntermediateStops, 'includeIntermediateStops');
        }
        if (excludeUnnecessaryTransfers !== undefined && excludeUnnecessaryTransfers !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>excludeUnnecessaryTransfers, 'excludeUnnecessaryTransfers');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<TripResponse>(`${this.configuration.basePath}/v3/trips/${encodeURIComponent(String(id))}/${encodeURIComponent(String(viaEarlierLaterContext))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * {Idempotent: GET with body payload} Perform a trip search starting at a position on a current &#x60;PTRideLeg&#x60; where a passenger is on its way on a planned Trip (aka search on trip (sot)).
     * Assuming there is a known disturbance coming, this API is useful to find other Trip options to get to the final destination from the view of the passenger\&#39;s current position.
     * @param tripsByLegRequestBody 
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTripsByLeg(tripsByLegRequestBody: TripsByLegRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<TripResponse>;
    public getTripsByLeg(tripsByLegRequestBody: TripsByLegRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<TripResponse>>;
    public getTripsByLeg(tripsByLegRequestBody: TripsByLegRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<TripResponse>>;
    public getTripsByLeg(tripsByLegRequestBody: TripsByLegRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (tripsByLegRequestBody === null || tripsByLegRequestBody === undefined) {
            throw new Error('Required parameter tripsByLegRequestBody was null or undefined when calling getTripsByLeg.');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<TripResponse>(`${this.configuration.basePath}/v3/trips/by-leg`,
            tripsByLegRequestBody,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * {Idempotent: GET with body payload} Get one-way trips between given origin and destination locations. Each Leg is operated by a certain transport-product, therefore multiple legs means changing vehicles.
     * The underlying public transportation planner will provide the best journey-connections according to your query-parameters, such as via, individual change time (ICT) etc.&lt;br&gt;Between 0 and about 12 hits are expectable, related to realtime circumstances.
     * @param tripsByOriginAndDestinationRequestBody 
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTripsByOriginAndDestination(tripsByOriginAndDestinationRequestBody: TripsByOriginAndDestinationRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<TripResponse>;
    public getTripsByOriginAndDestination(tripsByOriginAndDestinationRequestBody: TripsByOriginAndDestinationRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<TripResponse>>;
    public getTripsByOriginAndDestination(tripsByOriginAndDestinationRequestBody: TripsByOriginAndDestinationRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<TripResponse>>;
    public getTripsByOriginAndDestination(tripsByOriginAndDestinationRequestBody: TripsByOriginAndDestinationRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (tripsByOriginAndDestinationRequestBody === null || tripsByOriginAndDestinationRequestBody === undefined) {
            throw new Error('Required parameter tripsByOriginAndDestinationRequestBody was null or undefined when calling getTripsByOriginAndDestination.');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<TripResponse>(`${this.configuration.basePath}/v3/trips/by-origin-destination`,
            tripsByOriginAndDestinationRequestBody,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get road route by underlying router (no public transportation modes included). Returns one trip with very limited request options and response data.
     * @param origin Starting &#x60;StopPlace&#x60; of the trip at origin (departure). Only UIC number supported for now. 
     * @param destination Ending &#x60;StopPlace&#x60; of the trip at destination (arrival). Only UIC number supported for now. 
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTripsByRoad(origin: string, destination: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<TripResponse>;
    public getTripsByRoad(origin: string, destination: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<TripResponse>>;
    public getTripsByRoad(origin: string, destination: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<TripResponse>>;
    public getTripsByRoad(origin: string, destination: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (origin === null || origin === undefined) {
            throw new Error('Required parameter origin was null or undefined when calling getTripsByRoad.');
        }
        if (destination === null || destination === undefined) {
            throw new Error('Required parameter destination was null or undefined when calling getTripsByRoad.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (origin !== undefined && origin !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>origin, 'origin');
        }
        if (destination !== undefined && destination !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>destination, 'destination');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<TripResponse>(`${this.configuration.basePath}/v3/trips/by-road`,
            null,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * {Idempotent: GET with body payload} Get one-way trip-intervals for Public Transportation (PT) between given origin and destination &#x60;StopPlace&#x60;. Analog /trips but within duration interval.
     * The underlying public transportation planner will provide the best journey-connections according to your query-parameters, such as via, individual change time (ICT) etc.
     * @param tripsIntervalByOriginAndDestinationRequestBody 
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTripsIntervalByOriginAndDestination(tripsIntervalByOriginAndDestinationRequestBody: TripsIntervalByOriginAndDestinationRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<TripResponse>;
    public getTripsIntervalByOriginAndDestination(tripsIntervalByOriginAndDestinationRequestBody: TripsIntervalByOriginAndDestinationRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<TripResponse>>;
    public getTripsIntervalByOriginAndDestination(tripsIntervalByOriginAndDestinationRequestBody: TripsIntervalByOriginAndDestinationRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<TripResponse>>;
    public getTripsIntervalByOriginAndDestination(tripsIntervalByOriginAndDestinationRequestBody: TripsIntervalByOriginAndDestinationRequestBody, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (tripsIntervalByOriginAndDestinationRequestBody === null || tripsIntervalByOriginAndDestinationRequestBody === undefined) {
            throw new Error('Required parameter tripsIntervalByOriginAndDestinationRequestBody was null or undefined when calling getTripsIntervalByOriginAndDestination.');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (bearer-auth) required
        credential = this.configuration.lookupCredential('bearer-auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        // authentication (oauth2-azure-ad) required
        credential = this.configuration.lookupCredential('oauth2-azure-ad');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<TripResponse>(`${this.configuration.basePath}/v3/trips/intervals/by-origin-destination`,
            tripsIntervalByOriginAndDestinationRequestBody,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
